import React, { useState } from "react";

interface TooltipProps {
  content: React.ReactNode;
  children: React.ReactElement;
  wide?: boolean;
}

const Tooltip: React.FC<TooltipProps> = ({ content, children, wide = false }) => {
  const [isVisible, setIsVisible] = useState(false);

  const showTooltip = () => setIsVisible(true);
  const hideTooltip = () => setIsVisible(false);

  return (
    <div
      onMouseEnter={showTooltip}
      onMouseLeave={hideTooltip}
      style={{ position: "relative" }}
    >
      {children}
      {isVisible && (
        <div
          style={{
            position: "absolute",
            bottom: "100%",
            left: "50%",
            transform: "translateX(-50%)",
            padding: "8px",
            color: "white",
            backgroundColor: "#657DB8",
            borderRadius: "4px",
            border: "3px solid #657DB8",
            fontFamily: "Arial, sans-serif",
            fontSize: "18px",
            width: "1200px",
            maxWidth: "90vw",
          }}
        >
          {content}
        </div>
      )}
    </div>
  );
};

export default Tooltip;